import { bind } from 'decko'
import { LiveNodeList } from 'live-node-list'
import {
  getScrollProgress,
  goToSlide,
  registerSlideshow,
  unregisterSlideshow,
} from './slideshow-helpers'

export default class SlideshowButtons {
  buttons = new LiveNodeList('.slideshow-button')

  constructor() {
    this.registerListeners()
  }

  registerListeners() {
    this.buttons.addEventListener('click', this.scrollToTarget)
    this.buttons.on('update', (newItems, oldItems) => {
      newItems.forEach(this.registerSlideshow)

      oldItems.forEach(this.unregisterSlideshow)
    })

    this.buttons.forEach(this.registerSlideshow)
  }

  @bind
  registerSlideshow(item) {
    const target = document.getElementById(item.getAttribute('aria-controls'))
    registerSlideshow(item, {
      onScroll: this.handleScroll.bind(this, item, target),
    })
  }

  @bind
  unregisterSlideshow(item) {
    unregisterSlideshow(item, {
      onScroll: this.handleScroll.bind(this, item, target),
    })
  }

  @bind
  scrollToTarget(e) {
    const target = e.currentTarget || e.target
    const action = target.dataset.action
    const targetElement = document.getElementById(
      target.getAttribute('aria-controls'),
    )

    if (!targetElement) {
      return
    }

    const current =
      targetElement.querySelector('[aria-current="true"]') ||
      targetElement.firstElementChild
    const index = [...targetElement.children].indexOf(current)

    // let newElement = current[`${action}ElementSibling`]
    // while (newElement?.getAttribute('aria-hidden') === 'true') {
    //   newElement = newElement[`${action}ElementSibling`]
    // }
    //
    // if (!newElement) {
    //   return
    // }

    goToSlide(targetElement, action === 'next' ? index + 1 : index - 1)
  }

  @bind
  handleScroll(item, target) {
    const progress = getScrollProgress(target)
    if ('loop' in target.dataset) {
      item.removeAttribute('disabled')
      return
    }

    if (item.dataset.action === 'previous') {
      if (progress <= 0) {
        item.setAttribute('disabled', 'disabled')
      } else {
        item.removeAttribute('disabled')
      }
    }

    if (item.dataset.action === 'next') {
      if (progress >= 1) {
        item.setAttribute('disabled', 'disabled')
      } else {
        item.removeAttribute('disabled')
      }
    }
  }
}
